import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import AddChannelForm from "../../components/alerts/AddChannelForm";
import {
  Button,
  Card,
  Col,
  Table,
  Container,
  Row,
  Modal,
} from "react-bootstrap";
import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";
import Spinner from "react-bootstrap/Spinner";
import { useTable, TableOptions, useSortBy } from "react-table";

const PaginationTable = (props: TableOptions<Record<string, unknown>>) => {
  const { columns, data } = props;

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable({
      columns,
      data,
      defaultCanSort: false,
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        sortBy: [
          {
            id: "createdAt",
            desc: true,
          },
        ],
      },
      useSortBy,
    });

  return (
    <Card.Body className="float-none table-responsive">
      <Table striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {!rows.length ? (
            <tr>
              <td colSpan={10} className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Nalagam...</span>
                </Spinner>
              </td>
            </tr>
          ) : (
            rows.map((row: any, i: any) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell: any) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </Card.Body>
  );
};

const Alerts = () => {
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setOpenModal] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();
  const formRef = useRef<any>();
  const [alertChannel, setAlertChannel] = useState({
    id: null,
  });

  const tableColumns = [
    {
      Header: "Opis",
      accessor: "name",
    },
    {
      Header: "Način",
      accessor: "type",
    },
    {
      Header: "  ",
      accessor: (d: any) => {
        return d.value.length > 50 ? `${d.value.substring(0, 50)}...` : d.value;
      },
    },
    {
      Header: " ",
      accessor: (d: any) => {
        return (
          <Button
            variant="outline-secondary"
            className="float-end"
            onClick={() => {
              setAlertChannel(d);
              toggle();
            }}
          >
            Uredi
          </Button>
        );
      },
    },
  ];

  const toggle = (reload = false) => {
    setOpenModal(!isModalOpen);

    if (reload) {
      axios
        .get("/alerts/channels")
        .then((response) => setTableData(response.data.alertChannels))
        .catch((e) => console.error(e));
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    axios
      .get("/alerts/channels")
      .then((result) => {
        setTableData(result.data.alertChannels);
      })
      .catch((e) => console.error(e));
  }, [isAuthenticated]);

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  // const removeAlertChannel = () => {
  //   axios
  //     .delete("/alerts/channels/" + alertChannel.id)
  //     .then((response) => toggle(true))
  //     .catch((e) => console.error(e));
  // };

  return (
    <React.Fragment>
      <Helmet title="Nastavitve" />
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Nastavitve obveščanja</h1>

        <Row>
          <Col>
            <Card>
              <Card.Header>
                <Card.Title className="mb-0">Načini obveščanja</Card.Title>
              </Card.Header>
              <PaginationTable columns={tableColumns} data={tableData} />
              <Card.Footer>
                <Button
                  variant="primary"
                  onClick={() => {
                    setAlertChannel({ id: null });
                    toggle();
                  }}
                >
                  Dodaj
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal show={isModalOpen} onHide={() => toggle()}>
        <Modal.Header closeButton>
          <Modal.Title>
            {alertChannel.id
              ? "Uredi način za obveščanje"
              : "Dodaj način za obveščanje"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3">
          <AddChannelForm
            formRef={formRef}
            toggle={toggle}
            alertChannel={alertChannel}
          />
        </Modal.Body>
        <Modal.Footer>
          <Container>
            <Row className="d-flex">
              {/*{alertChannel.id ? (
                <Col className="text-start">
                  <Button variant="outline-danger" onClick={removeAlertChannel}>
                    Odstrani
                  </Button>
                </Col>
              ) : (
                ""
              )}*/}
              <Col className="text-end">
                <Button variant="primary" onClick={submitForm}>
                  Shrani
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Alerts;
